<template>
  <v-card class="pa-4 ma-1 user-note" flat>
    <div class="note-title">
      {{ note.by_first_name }} -
      {{ formatDate(new Date(note.created_at).toISOString().substr(0, 10)) }}
    </div>
    <div>
      <pre>{{ note.body }}</pre>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    note: { type: Object }
  },
  methods: {
    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split("-")
      return `${month}/${day}/${year}`
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../scss/variables";

pre {
  font-family: $main-font-family;
  color: $dark-grey;
  padding: 0px 20px 10px 20px;
  margin: 0px;
  border-bottom: 1px solid $beige;
  white-space: pre-wrap; /* css-3 */
  white-space: -moz-pre-wrap; /* Mozilla, since 1999 */
  white-space: -pre-wrap; /* Opera 4-6 */
  white-space: -o-pre-wrap; /* Opera 7 */
  word-wrap: break-word; /* Internet Explorer 5.5+ */
}
pre:hover {
  background: $beige !important;
}
.note-title {
  text-transform: uppercase;
  color: $dark-grey;
  font-size: 1em;
}
</style>
